<style src="css/common.css"></style>
<style scoped>
    #app{
        max-width: 7.5rem;
        margin: 0 auto;
    }
  .messageIcon{
    position: fixed;
    bottom: 2.28rem;
    right: .28rem;
    background: url("~assets/message.png") no-repeat center/cover;
    width: .95rem;
    height: .95rem;
    border-radius: 50%;
  }
  .messageIcon2{
    position: fixed;
    bottom: 3.5rem;
    right: .28rem;
    background: url("~assets/message2.png") no-repeat center/cover;
    width: .95rem;
    height: .95rem;
    border-radius: 50%;
  }
</style>
<template>
  <div id="app">
    <router-view/>
    <div class="messageIcon" @click="toDetail()" v-if="show"></div>
    <div class="messageIcon2" @click="toDetail2()" v-if="show2"></div>
  </div>
</template>
<script>
    import "normalize.css"
    import {getSource, getSources} from "./api"
    export default {
      name: 'app',
        data() {
            return {
               show:false,
               show2:false,
                token:this.$route.query.token?this.$route.query.token:localStorage.getItem('token')?localStorage.getItem('token'):'',
                id:this.$route.query.id?this.$route.query.id:localStorage.getItem('id')?localStorage.getItem('id'):'',
//                num:1,
            }
        },

        mounted() {
          // console.log(this.$route.fullPath)
          // console.log(this.$route.query.code)
            // this.forScaleUserLogin()
            // this.webSocket();

            if(!localStorage.getItem('doctorId') && this.$route.path!=='/login' && this.$route.path!=='/wx-auth'){
                if(this.$route.query.code){
                    this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
                }else{
                    this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
                }

//                location.href = "/login"
            }
            window.onload = function () {
                // 禁止双指缩放
                document.addEventListener('touchstart', function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                });
                // 禁止ios 双击缩放
                let lastTouchEnd = 0;
                document.addEventListener('touchend', function (event) {
                    let now = (new Date()).getTime();
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault();
                    }
                    lastTouchEnd = now;
                }, false);
                document.addEventListener('gesturestart', function (event) {
                    event.preventDefault()
                });
            }

        },
        methods:{
            // async forScaleUserLogin() {
            //     let data = await getSources("/bear-scale/api/scaleUserInfo/forScaleUserLogin.json",{
            //         id:this.id,
            //         token:this.token
            //     });
            //     if (data.status === 0) {
            //         localStorage.setItem('loginType',data.loginType)
            //         localStorage.setItem('companyLogo',data.companyLogo)
            //         localStorage.setItem('token',this.token)
            //         localStorage.setItem('id',this.id)
            //     }else{
            //         // alert(data.msg)
            //     }
            // },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },
            toDetail(){

                this.show=false;
                this.$router.push(`/askExpert?${Math.random()}`)
            },
            toDetail2(){
                this.show2=false;
                this.$router.push(`/psychologyList?${Math.random()}`)
            },
            webSocket() {

                let that = this;
                let websocket = null;
                //判断当前浏览器是否支持WebSocket

                let doctorId=localStorage.getItem('doctorId')

//                "wss://www.liminghulian.com/websocket");
                if ('WebSocket' in window) {

                    if (doctorId) {
//                      线上
                        websocket = new WebSocket(`wss://www.itnbear.com/doctorSocket/?doctorId=${doctorId}`);
//                        248测试
//                        websocket = new WebSocket(`ws://192.168.3.105:8091/bear-scale/doctorSocket/${doctorId}`);
//                        websocket = new WebSocket(`wss://106.54.86.69:8091/bear-scale/doctorSocket/${doctorId}`);
//                        websocket = new WebSocket(`ws://192.168.0.233:8088/depression-mip/myWebSocket/${doctorId}`);
                    } else {
                        websocket = new WebSocket(`wss://www.itnbear.com/doctorSocket/?doctorId=-1`);


//                        websocket = new WebSocket(`ws://192.168.0.247:8088/depression-mip/myWebSocket/-1`);
//                        websocket = new WebSocket(`ws://192.168.3.105:8091/bear-scale/doctorSocket/-1`);
//                        websocket = new WebSocket(`ws://106.54.86.69:8091/bear-scale/doctorSocket/-1`);
                    }
                }
                else {
                    alert('当前浏览器不支持websocket');
                }

                //发送消息
                function send() {
                    var message = document.getElementById('text').value;
                    websocket.send(message);
                }


                //接收到消息的回调方法
                websocket.onmessage = function (event) {
                    console.log(event)
                    heartCheck.reset().start();
                    let data = JSON.parse(event.data);
                    console.log(data)

                    if (data) {
//                        console.log(that.$store.state.info)
                        that.$store.commit('setInfo', data)
                        // that.$store.commit('setInfo2', data)

//                         if(data.qid){
//                             that.show=true
//                         }else{
//                             that.show2=true
//                         }

                    }
                }

                //连接成功建立的回调方法
                websocket.onopen = function () {
                    heartCheck.reset().start();
                    console.log("onopen...");
                }
                //连接关闭的回调方法
                websocket.onclose = function () {
                    console.log("onclose...");
                }
                //连接发生错误的回调方法
                websocket.onerror = function () {
                    console.log("onerror...");
                };
                //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = function () {
                    closeWebSocket();
                }

                //关闭WebSocket连接
                function closeWebSocket() {
                    websocket.close();
                }

                // 心跳检测, 每隔一段时间检测连接状态，如果处于连接中，就向server端主动发送消息，来重置server端与客户端的最大连接时间，如果已经断开了，发起重连。
                var heartCheck = {
                    timeout: 55000,        // 9分钟发一次心跳，比server端设置的连接时间稍微小一点，在接近断开的情况下以通信的方式去重置连接时间。
                    serverTimeoutObj: null,
                    reset: function () {
                        clearTimeout(this.timeoutObj);
                        clearTimeout(this.serverTimeoutObj);
                        return this;
                    },
                    start: function () {
                        var self = this;
                        this.serverTimeoutObj = setInterval(function () {
                            if (websocket.readyState == 1) {
                                console.log("连接状态，发送消息保持连接");
                                websocket.send("ping");
                                heartCheck.reset().start();    // 如果获取到消息，说明连接是正常的，重置心跳检测
                            } else {
                                console.log("断开状态，尝试重连");
                                self.webSocket()
                            }
                        }, this.timeout)
                    }
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/App.vue